module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_9016.5cccd49f.png";